export default __webpack_public_path__ + "static/media/PG19-1.7c2994c4.png";